import VacancyMatchingToggleSection from './VacancyMatchingToggleSection.component';

export default VacancyMatchingToggleSection;